<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入商品名称" v-model="queryParam.materialName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入编码" v-model="queryParam.code"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset(11)">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->

        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
            @change="handleTableChange" style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <a type="primary" @click="toProductLicense(record, 1)" :disabled="record.state == 2 || record.state == 3">审批</a>
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="orange">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <!-- <productModal ref="productModal" @ok="modalFormOk" @close="modalFormClose"></productModal> -->
        <a-modal :visible="showModal" @close="closeProductModal" :width="modal.width" @ok="closeProductModal" @cancel="closeProductModal">
          <template slot="footer">
                <a-button @click="closeProductModal">关闭</a-button>
                <a-popconfirm v-if="this.isApproval == true" title="是否通过审批?" ok-text="通过" cancel-text="不通过" @confirm="() => handleAudit(2)" @cancel="() => handleAuditCancel(3)">
                    <a-button type="primary">审批</a-button>
                </a-popconfirm>
            </template>
          <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="1" tab="商品信息">
              <productInfo ref="productInfo" @ok="modalFormOk" @close="modalFormClose" :productInfo="productInfo"></productInfo>
            </a-tab-pane>
            <a-tab-pane key="2" tab="证照信息" force-render>
              <productLicense ref="productLicense" @ok="modalFormOk" @close="modalFormClose" :productInfo="productInfo"></productLicense>

            </a-tab-pane>
          </a-tabs>

        </a-modal>

      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//ledgerAdd

import addModel from '../modules/addModel'
import productLisenceDetail from '../modules/productLisenceDetail'
import productModal from '../modules/productModal'
import { campListMixins } from '../mixins/campListMixins'
import { ledgerDelete,ledgerEdit, getProductDetail, materialApproval, companyApprovalDetail, editApproval} from '@/api/api'
import JDate from '@/components/jeecg/JDate'
import Product from '../product'
import productInfo from '../modules/productInfo'
import productLicense from '../modules/productLicense'


export default {
  name: 'RetailOutList',
  mixins: [campListMixins],
  components: {
    productInfo,
    productLicense,
    JDate,
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      modal: {
        width: '1474px',
        dialogStyle: { top: '80px' },
        fullScreen: false
      },
      matype: {

      },
      isApproval: false,
      productInfo: {},
      recordApprovalId: '',
      recordApprovalState: '',
      activeKey: "1",
      showModal: false,
      // 查询条件
      queryParam: {
        licenceType: '1'
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '商品名称', dataIndex: 'materialName', width: 160 ,ellipsis: true, render: (text) => text || "--" },
        { title: '编码', dataIndex: 'code', width: 220, render: (text) => text || "--" },
        { title: '规格/型号', dataIndex: 'model',width: 160, render: (text) => text || "--"},
        { title: '单位', dataIndex: 'unit', width: 140, render: (text) => text || "--" },
        { title: '状态', dataIndex: 'state',width: 100, scopedSlots: { customRender: 'state' }, render: (text) => text || "--"},
        { title: '审核人', dataIndex: 'Approver',width: 100,render: (text) => text || "--"},
        { title: '审核时间', dataIndex: 'ApprovalTime',width: 100,render: (text) => text || "--"},
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          // fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/sy/examine/licenceExamine/list',

      },
    }
  },
  computed: {},
  created() {

  },
  methods: {
    addLicense(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalLicense.initShow(record)
    },
    closeProductModal(){
      this.showModal = false
    },
    handleCancel(){
      this.showModal = false
    },
    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    async handleAudit(e) {
      console.log(this.recordApprovalId,'==========uuid=?===========')
        let params = {
            uuid : this.recordApprovalId,
            state: e
        }
        const res = await editApproval(params)
        if (res.code == 200 && res.success == true) {
            this.$message.success(res.message)
            this.showModal = false
            this.loadData()
        } else {
            this.$message.error(res.message)
        }
    },
    async handleAuditCancel(e){
      console.log(this.recordApprovalId,'==========uuid=?===========')
        let params = {
            uuid : this.recordApprovalId,
            state: e
        }
        const res = await editApproval(params)
        if (res.code == 200 && res.success == true) {
            this.$message.success(res.message)
            this.showModal = false
            this.loadData()
        } else {
            this.$message.error(res.message)
        }
    },
    //审批
    async productApprocal(record){
      console.log(record,'审核record============')
      let params = {
        materialId : record.materialId,
      }
      const res = await materialApproval(params)
      if(res.code == 200 && res.success == true){
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
      this.loadData()
    },
    //handleAuditCancel
    // async handleAuditCancel(record,e) {
    //   console.log(record,'审核record============')
    //   let params = {
    //     uuid : record.uuid,
    //     state: e
    //   }
    //   const res = await ledgerEdit(params)
    //   this.loadData()
    // },
    // 添加商品证照
    productLicense(record){

    },
    //查看商品证照列表
    async toProductLicense(record,num){

      let params = {
        examineId : record.uuid,
        licenceType: num
      }
      const res = await companyApprovalDetail(params)
      if(res.code == 200 && res.success == true){
        this.showModal = true
        this.recordApprovalId = record.uuid
        console.log(record,'ooooooooooooooooooo===========uuuuuuuuuuuuuu')
        // this.recordApprovalState =
        if(num == 1){
          this.isApproval = true

        }
        this.productInfo = res.result
      } else {
        this.$message.error(res.message)
      }

    },
    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.uuid
      }
      const res = await ledgerDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>